module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.group = 0
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.group = 1
      }
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.group = 2
      }
    }
  }, [_vm._v("E-mail")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Pretraga po:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nickname",
      "selected": ""
    }
  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "firstname"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lastname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "color"
    }
  }, [_vm._v("Color")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "term"
    }
  }, [_vm._v("Traži")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "term",
      "placeholder": "Traži"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "keyup": function($event) {
        _vm.searchUser()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Name | E-mail")]), _vm._v(" "), _c('th', [_vm._v("Age range")]), _vm._v(" "), (_vm.role >= 40) ? _c('th', [_vm._v("Pwd")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(user.id))]), _vm._v(" "), _c('td', [_c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.changeNick($event)
        }
      }
    }, [_c('input', {
      staticClass: "user-id",
      attrs: {
        "type": "hidden",
        "name": "user_id"
      },
      domProps: {
        "value": user.id
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "form-control user-nickname",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm.testUri(user.nickname)
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Sačuvaj")])])]), _vm._v(" "), (user.facebook_id != null) ? _c('td', [_c('a', {
      attrs: {
        "href": 'https://facebook.com/' + user.facebook_id
      }
    }, [_vm._v("fb: " + _vm._s(user.firstname) + " " + _vm._s(user.lastname))])]) : _c('td', [_vm._v("\n          " + _vm._s(user.email) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.age_range))]), _vm._v(" "), (_vm.role >= 40) ? _c('td', [_vm._v(_vm._s(user.password_view))]) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.aboutUser(user)
        }
      }
    }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.deleteUser(user.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.numberOfPages), function(cnt) {
    return _c('li', [_c('a', {
      class: [cnt == _vm.currentPage ? 'active' : ''],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.changePage(cnt)
        }
      }
    }, [_vm._v(_vm._s(cnt))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "myModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.userInfo.id != 0) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "user_id"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user_id",
      "disabled": ""
    },
    domProps: {
      "value": _vm.userInfo.id
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nickname"
    },
    domProps: {
      "value": _vm.testUri(_vm.userInfo.nickname)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": _vm.userInfo.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "password_view"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "password_view"
    },
    domProps: {
      "value": _vm.userInfo.password_view
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "coins"
    }
  }, [_vm._v("Coins:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "coins"
    },
    domProps: {
      "value": _vm.userInfo.coins
    }
  })])]), _vm._v(" "), (_vm.userInfo.facebook_id != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Facebook:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": 'https://facebook.com/' + _vm.userInfo.facebook_id
    }
  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Age Range: " + _vm._s(_vm.userInfo.age_range))])])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.userInfo.skins.length) ? _c('div', {
    staticClass: "ui six stackable cards",
    attrs: {
      "id": "skins-cards"
    }
  }, _vm._l((_vm.userInfo.skins), function(item) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4 col-lg-3 card",
      attrs: {
        "data-skin-id": item.id
      }
    }, [_c('img', {
      staticClass: "card-img-top",
      attrs: {
        "src": 'https://agar.rs/public/images/skins/' + item.skin_name + '.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "card-text"
    }, [_vm._v("\n                        " + _vm._s(item.ip) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('button', {
      staticClass: "btn btn-danger float-right btn-sm",
      on: {
        "click": function($event) {
          _vm.removePrivateSkinDB(item.id, item.skin_name)
        }
      }
    }, [_vm._v("Delete")])])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Users\n      "), _c('small', [_vm._v("List of users")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Informacije o igraču:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "skins-cards"
    }
  }, [_vm._v("Private skins:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f23be5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/users/Index.vue
// module id = 307
// module chunks = 2